import * as React from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";

import { GettingStartedLayout } from "components/products/GettingStartedLayout";
import { LicenseData } from "domain/licenses";
import { OnboardingProductType } from "domain/onboardings";
import { OnboardingImage, SoftwarePackage, Versions } from "domain/softwarePackages";
import { StoreState } from "store";

const mapState = (state: StoreState) => ({
    theme: state.themeReducer.theme,
});

const connector = connect(mapState);

interface Props {
    fetchedSoftwarePackages?: SoftwarePackage[];
    licenses: Versions[];
    fetchedLicenses: LicenseData[];
    saveBdeOnboarded: (onboarded: boolean) => void;
    showBmpSetup: boolean;
    saveLastCompletedStep: (step: string) => void;
    fetchedOnboardingImages: OnboardingImage[];
}
export const GettingStarted = (props: Props): JSX.Element => {
    const { t } = useTranslation();

    return (
        <>
            <GettingStartedLayout
                product={OnboardingProductType.BDE}
                visible={true}
                footerVisibility={false}
                extraHeaderText={t("Onboarding.gettingStartedFlow.blanccoDriveErasureProduct")}
                title={t("Onboarding.gettingStartedFlow.title")}
                description={t("Onboarding.gettingStartedFlow.flowDescription")}
                licenses={props.licenses}
                fetchedSoftwarePackages={props.fetchedSoftwarePackages}
                fetchedLicenses={props.fetchedLicenses}
                saveBdeOnboarded={props.saveBdeOnboarded}
                showBmpSetup={props.showBmpSetup}
                saveLastCompletedStep={props.saveLastCompletedStep}
                fetchedOnboardingImages={props.fetchedOnboardingImages}
            />
        </>
    );
};

export default connector(GettingStarted);
